import React, { useState } from 'react';
import clsx from 'clsx';
import { NumberFormat } from 'components';
import PropTypes from 'prop-types';
import { makeStyles } from '@material-ui/styles';
import { Search } from 'components/SearchBar/components';
import { useSelector } from 'react-redux';
import {
  Modal,
  Card,
  CardContent,
  CardActions,
  Button,
  CardHeader,
  Divider,
  TableHead,
  Table,
  TableBody,
  TableCell,
  TableRow,
  Grid
} from '@material-ui/core';

const useStyles = makeStyles(theme => ({
  root: {
    position: 'absolute',
    top: '50%',
    left: '50%',
    transform: 'translate(-50%, -50%)',
    outline: 'none',
    boxShadow: theme.shadows[20],
    width: 850,
    maxHeight: '100%',
    overflowY: 'auto',
    maxWidth: '100%'
  },
  content: {
    padding: 0
  },
  actions: {
    justifyContent: 'flex-end'
  },
  progress: {
    marginBottom: theme.spacing(2)
  },
  fileName: {
    marginBottom: theme.spacing(2)
  },
  image: {
    width: '100%'
  },
  details: {
    padding: theme.spacing(2)
  },
  comment: {
    flexGrow: 1,
    padding: theme.spacing(1),
    borderRadius: theme.shape.borderRadius,
    backgroundColor: theme.palette.background.default,
    borderColor: 'transparent',
    borderStyle: 'solid',
    borderWidth: 1,
    position: 'relative',
    marginTop: theme.spacing(1)
  },
  search: {
    minWidth: 480,
    maxWidth: 480,
    flexBasis: 480
  },
  tableContainer: {
    minHeight: 450,
    maxHeight: 450,
    overflowY: 'auto'
  },
  searchContainer: {
    padding: theme.spacing(2)
  },
  selfSearch: {
    marginTop: 3
  },
  buttonCell: {
    paddingTop: 0,
    paddingBottom: 0
  },
  buttonExtraSmall: {
    padding: '1px 8px',
    fontSize: '0.8125rem'
  },
  actionsColumn: {
    width: 100
  }
}));

const EventDataSetSelect = props => {
  const {
    open,
    onClose,
    eventDataSets,
    onSelectEventDataSet,
    className,
    ...rest
  } = props;

  const classes = useStyles();

  const loading = false;
  const [searchName, setSearchName] = useState('');
  const { sessionUser } = useSelector(state => state.session);

  const findEventDataSetsByName = searchName => {
    return eventDataSets.filter(eventDataSet => {
      return (
        searchName === '' ||
        eventDataSet.name.toUpperCase().indexOf(searchName.toUpperCase()) !== -1
      );
    });
  };

  const findFirstEventDataSetByName = searchName => {
    const eventDataSets = findEventDataSetsByName(searchName);
    return eventDataSets.length > 0 ? eventDataSets[0] : null;
  };

  const searchedEventDataSets = findEventDataSetsByName(searchName);
  const userEventDataSet = findFirstEventDataSetByName(sessionUser.displayName);

  const handleClose = () => {
    onClose();
  };

  const handleSearchFieldChange = value => {
    setSearchName(value);
  };

  if (!open) {
    return null;
  }

  return (
    <Modal onClose={handleClose} open={open}>
      <Card {...rest} className={clsx(classes.root, className)}>
        <CardHeader title="Select Walk Collection" />
        <Divider />

        <CardContent className={classes.content}>
          <div className={classes.searchContainer}>
            <Grid container spacing={3}>
              <Grid item>
                <Search
                  placeholder="Name"
                  value={searchName}
                  onSearchValueChange={handleSearchFieldChange}
                  className={classes.search}
                  hideSearchButton={true}
                />
              </Grid>
            </Grid>
          </div>
          <Divider />
          <div className={classes.tableContainer}>
            <Table>
              <TableHead>
                <TableRow>
                  <TableCell className={classes.actionsColumn}>
                    Actions
                  </TableCell>
                  <TableCell>Name</TableCell>
                  <TableCell>Walks</TableCell>
                  <TableCell>Description</TableCell>
                </TableRow>
              </TableHead>
              <TableBody>
                {searchedEventDataSets.map(dataSet => (
                  <TableRow key={dataSet.id} hover>
                    <TableCell className={classes.buttonCell}>
                      <Button
                        className={classes.buttonExtraSmall}
                        color="primary"
                        size="small"
                        variant="outlined"
                        onClick={() => onSelectEventDataSet(dataSet)}>
                        Select
                      </Button>
                    </TableCell>
                    <TableCell>{dataSet.name}</TableCell>
                    <TableCell>
                      <NumberFormat value={dataSet.eventCount} />
                    </TableCell>
                    <TableCell>{dataSet.description}</TableCell>
                  </TableRow>
                ))}
                {!loading && searchedEventDataSets.length === 0 && (
                  <TableRow>
                    <TableCell colSpan={10}>No data available</TableCell>
                  </TableRow>
                )}
              </TableBody>
            </Table>
          </div>
        </CardContent>
        <CardActions className={classes.actions}>
          <Button onClick={handleClose} variant="contained">
            Done
          </Button>
        </CardActions>
      </Card>
    </Modal>
  );
};

EventDataSetSelect.displayName = 'EventDataSetSelect';

EventDataSetSelect.propTypes = {
  className: PropTypes.string
};

export default EventDataSetSelect;
